;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('invoiceStatus', Status)

  Status.$inject = []

  function Status () {
    return {
      restrict: 'E',
      replace: true,
      template: '<span class="label" ng-class="ctrl.cssClass">{{ctrl.label}}</span>',
      bindToController: {
        type: '<',
        status: '<'
      },
      controllerAs: 'ctrl',
      controller: ['$filter', 'StatusService', function ($filter, StatusService) {
        this.$onInit = () => {
          this.label = $filter('status')(this.type, this.status)
          this.cssClass = 'label-' + StatusService.getCssClass(this.type, this.status)
        }
      }]
    }
  }
})(window.angular)
